function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.44 98.7232C67.44 93.5392 71.508 89.6152 76.836 89.6152C82.164 89.6152 86.232 93.4672 86.232 98.6512C86.232 100.919 85.404 103.367 83.748 105.923L78.024 114.779H71.904L77.448 106.787C76.872 107.039 76.188 107.111 75.648 107.111C70.896 107.111 67.44 103.331 67.44 98.7232ZM72.66 98.5432C72.66 100.847 74.532 102.647 76.836 102.647C79.176 102.647 81.012 100.847 81.012 98.5791C81.012 96.2751 79.176 94.4391 76.872 94.4391C74.532 94.4391 72.66 96.2752 72.66 98.5432Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0343 102.431C89.0343 95.6992 92.5983 89.6152 99.6183 89.6152C106.638 89.6152 110.202 95.6992 110.202 102.431C110.202 109.163 106.638 115.247 99.6183 115.247C92.5983 115.247 89.0343 109.163 89.0343 102.431ZM104.838 102.431C104.838 98.5072 103.254 94.6191 99.6183 94.6191C95.9823 94.6191 94.3983 98.5072 94.3983 102.431C94.3983 106.355 95.9823 110.243 99.6183 110.243C103.254 110.243 104.838 106.355 104.838 102.431Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.242 95.6992C125.242 99.0472 122.47 101.639 119.05 101.639C115.63 101.639 112.894 99.0472 112.894 95.6992C112.894 92.3512 115.63 89.7591 119.05 89.7591C122.47 89.7591 125.242 92.3512 125.242 95.6992ZM119.05 98.1832C120.454 98.1832 121.462 97.1032 121.462 95.6992C121.462 94.2952 120.454 93.2151 119.05 93.2151C117.646 93.2151 116.638 94.2952 116.638 95.6992C116.638 97.1032 117.646 98.1832 119.05 98.1832ZM119.95 114.779H115.162L133.486 90.0471H138.274L119.95 114.779ZM134.35 115.067C130.93 115.067 128.194 112.475 128.194 109.127C128.194 105.779 130.93 103.187 134.35 103.187C137.806 103.187 140.542 105.779 140.542 109.127C140.542 112.475 137.806 115.067 134.35 115.067ZM134.35 111.611C135.754 111.611 136.798 110.531 136.798 109.127C136.798 107.723 135.754 106.643 134.35 106.643C132.946 106.643 131.938 107.723 131.938 109.127C131.938 110.531 132.946 111.611 134.35 111.611Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.929 11.6205C110.416 5.84553 106.122 0.712412 100.327 0.821029C79.5612 1.21028 59.3147 7.93654 42.3654 20.2262C22.572 34.5779 8.59214 55.5618 2.97194 79.356C-2.64826 103.15 0.465132 128.171 11.7451 149.863C23.025 171.554 41.721 188.472 64.4279 197.536C87.1348 206.599 112.342 207.205 135.458 199.243C158.574 191.281 178.061 175.28 190.37 154.156C202.679 133.032 206.991 108.189 202.521 84.1523C198.692 63.5693 188.642 44.7502 173.852 30.1686C169.725 26.0999 163.076 26.8648 159.453 31.3878C155.829 35.9108 156.618 42.4725 160.635 46.6498C171.552 58.0029 178.98 72.3558 181.887 87.9899C185.438 107.081 182.013 126.812 172.237 143.59C162.461 160.368 146.983 173.076 128.623 179.4C110.263 185.724 90.2429 185.242 72.2081 178.044C54.1733 170.845 39.3241 157.408 30.3651 140.18C21.4061 122.952 18.9333 103.079 23.3971 84.1804C27.8609 65.2821 38.9643 48.6158 54.6851 37.217C67.5592 27.8822 82.8283 22.5887 98.5629 21.8738C104.352 21.6108 109.442 17.3955 109.929 11.6205Z",
    fill: "url(#paint0_linear_27_419)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_419",
    x1: -12.1943,
    y1: 92.0267,
    x2: 228.364,
    y2: 92.9103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C",
    style: {
      stopColor: "#AA367C",
      stopColor: "color(display-p3 0.6667 0.2118 0.4863)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD",
    style: {
      stopColor: "#4A2FBD",
      stopColor: "color(display-p3 0.2902 0.1843 0.7412)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter90);
export default __webpack_public_path__ + "static/media/meter_90.e56a4082439ec092feae1c74bc30c3cc.svg";
export { ForwardRef as ReactComponent };